module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f467-1f3ff.aec96b45.svg";